import React, { useState, useRef, useCallback, useEffect } from 'react'
import './BeforeAfter.css'

const BeforeAfter = ({ beforeSrc, afterSrc, altBefore = 'До', altAfter = 'После' }) => {
  const [position, setPosition] = useState(50)
  const [afterLoaded, setAfterLoaded] = useState(false)
  const [beforeLoaded, setBeforeLoaded] = useState(false)
  const isLoaded = afterLoaded && beforeLoaded
  const containerRef = useRef(null)
  const isDragging = useRef(false)

  useEffect(() => {
    setAfterLoaded(false)
  }, [afterSrc])

  useEffect(() => {
    setBeforeLoaded(false)
  }, [beforeSrc])

  const updatePosition = useCallback((clientX) => {
    const rect = containerRef.current.getBoundingClientRect()
    const x = clientX - rect.left
    const percent = Math.min(Math.max((x / rect.width) * 100, 0), 100)
    setPosition(percent)
  }, [])

  const handlePointerDown = useCallback((e) => {
    isDragging.current = true
    e.currentTarget.setPointerCapture(e.pointerId)
    updatePosition(e.clientX)
  }, [updatePosition])

  const handlePointerMove = useCallback((e) => {
    if (!isDragging.current) return
    updatePosition(e.clientX)
  }, [updatePosition])

  const handlePointerUp = useCallback(() => {
    isDragging.current = false
  }, [])

  return (
    <div
      className="before-after"
      ref={containerRef}
    >
      <div
        className={`before-after__skeleton img-skeleton ${isLoaded ? 'is-hidden' : ''}`}
        aria-hidden="true"
      />

      <img
        className={`before-after__img before-after__img--after img-fade-in ${afterLoaded ? 'is-loaded' : ''}`}
        src={afterSrc}
        alt={altAfter}
        draggable={false}
        onLoad={() => setAfterLoaded(true)}
      />

      <div
        className="before-after__before-clip"
        style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
      >
        <img
          className={`before-after__img before-after__img--before img-fade-in ${beforeLoaded ? 'is-loaded' : ''}`}
          src={beforeSrc}
          alt={altBefore}
          draggable={false}
          onLoad={() => setBeforeLoaded(true)}
        />
      </div>

      <div
        className="before-after__slider"
        style={{ left: `${position}%` }}
      >
        <div className="before-after__line" />
        <div
          className="before-after__handle"
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={handlePointerUp}
          onPointerCancel={handlePointerUp}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 19l-7-7 7-7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 5l7 7-7 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  )
}

export default BeforeAfter
